module.exports = __webpack_public_path__ + "static/media/FinishHandImg.0d7c01d0.png";